import $ from "jquery";

$(function () {

    if ($(".production").length > 0) {
        const currentUrl = window.location.href;
        const menuLinks = document.querySelectorAll(".production_menu a");

        // Loop through each link and check if it matches the current URL
        menuLinks.forEach(link => {
            if (link.href === currentUrl) {
                link.classList.add("active");
            }
        });
    }

});
